<script lang="ts">
  import {onMount} from 'svelte'
  import {_} from 'svelte-i18n'
  import {initFavorites, search} from './services'

  import FavoritesInfiniteScroll from './components/FavoritesInfiniteScroll/FavoritesInfiniteScroll.svelte'
  import FavoritesNoItemsBanner from './components/FavoritesNoItemsBanner/FavoritesNoItemsBanner.svelte'
  import FavoritesPreviewCards from './components/FavoritesPreviewCards/FavoritesPreviewCards.svelte'
  import FavoritesLoader from './components/FavoritesLoader/FavoritesLoader.svelte'
  import GeneralLayout from '../../layouts/GeneralLayout.svelte'
  import NewslineAllViewModal from '../Newsline/components/NewslineAllViewModal/NewslineAllViewModal.svelte';
  import GlobalSearch from "../../custom/GlobalSearch/GlobalSearch.svelte";
  import GlobalSearchTags from "../../custom/GlobalSearch/GlobalSearchTags.svelte";
  import GlobalSearchInfo from "../../custom/GlobalSearch/GlobalSearchInfo.svelte";
  import {isDirtySearch, list} from "../../stores";
  import ContentTitle from '../../custom/ContentTitle.svelte';

  onMount(initFavorites)
</script>

<GeneralLayout>
  <GlobalSearch on:search={search}/>
  <GlobalSearchTags on:search={search}/>

  {#if $isDirtySearch}
    <GlobalSearchInfo
      searchResults={[{list: $list, count: $list.length, order: 1, title: $_('favorites')}]}
    />
  {:else}
    <ContentTitle title={$_('favorites')} />
    <FavoritesPreviewCards />
    <FavoritesNoItemsBanner />
  {/if}
  <FavoritesLoader />
</GeneralLayout>

<FavoritesInfiniteScroll />
<NewslineAllViewModal />